import { useContext } from "react";

import { Form } from "formik";
import PropTypes from "prop-types";

import { Section, GrabsonIcon } from "components/layout";

import { ManifestEditButtons } from ".";
import { ManifestDataContext } from "../../ManifestData";
import { ManifestEditField } from "../fields";
import { getTabsConfig } from "../utils";
import styles from "./ManifestEdit.scss";

export function ManifestEditForm({ tabId, controls = false }) {
  const { app } = useContext(ManifestDataContext);
  const tabData = getTabsConfig(app.type).find((tab) => tab.id === tabId);

  return (
    <Form aria-label="form" className={styles.formContent}>
      <Section header={tabData.header()} className={styles.section}>
        {controls && <ManifestEditButtons />}

        {tabData.description && (
          <p className={styles.warning} data-test-id="manifest-section-warning">
            <GrabsonIcon
              className={styles.warningIcon}
              name="alert-circle"
              font="micro"
              size="xl"
            />
            {tabData.description()}
          </p>
        )}
        {tabData.fields.map((field) => (
          <ManifestEditField key={field.name} {...field} />
        ))}

        {controls && <ManifestEditButtons position="bottom" />}
      </Section>
    </Form>
  );
}

ManifestEditForm.propTypes = {
  controls: PropTypes.bool,
  tabId: PropTypes.string.isRequired,
};
